<section class="topBar" id="topBar">
    <dx-drop-down-button keyExpr="id" displayExpr="text" stylingMode="text" text="Help" icon="/css/images/help_white.svg" [items]="helpActions" [dropDownOptions]="dropDownOptions"
        (onItemClick)="onItemClick($event)">
    </dx-drop-down-button>
    <dx-drop-down-button keyExpr="id" displayExpr="text" stylingMode="text" text="{{currentUser?.DisplayName}}" icon="/css/images/account_circle_white.svg" [items]="userActions"
        [dropDownOptions]="dropDownOptions" (onItemClick)="onItemClick($event)">
    </dx-drop-down-button>
    <div class="environment" [class.colored]="environmentColor" [style.--env-color]="environmentColor">
        <span>{{activeEnvironment}}</span>
    </div>
</section>

<ng-template #versionTemplate let-c="close" let-d="dismiss">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Versions</h4>
    </div>
    <div class="form-group modal-body">
        <dx-data-grid exportFileName="Versions" [dataSource]='hostInfos' [selection]='{ mode: "none" }' [masterDetail]="{ enabled: true, template: 'runningInstancesTemplate' }">

            <dxi-column dataField="Host.Name" caption="Type" dataType="string" sortOrder="asc"></dxi-column>
            <dxi-column dataField="LatestVersion" caption="Version" dataType="string"></dxi-column>
            <dxi-column dataField="LatestInstalledTime" caption="Latest Container Startup" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
            <dxi-column dataField="LatestBuildTime" caption="Latest Build Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
            <dxi-column dataField="LatestUpdatedTime" caption="Last Ping Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
            <dxi-column dataField="CurrentVersions.length" caption="Running Instances" dataType="number"></dxi-column>
            <div *dxTemplate="let host of 'runningInstancesTemplate'">
                <div>
                    <label>Running instances:</label>
                    <dx-data-grid [dataSource]='host.data.CurrentVersions' [columnAutoWidth]='true'>
                        <dxi-column dataField="ServerName" caption="Server" dataType="string"></dxi-column>
                        <dxi-column dataField="Version" caption="Version" dataType="string"></dxi-column>
                        <dxi-column dataField="Installed" caption="Container Startup" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
                        <dxi-column dataField="Builded" caption="Build Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
                        <dxi-column dataField="Updated" caption="Last Ping Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
                    </dx-data-grid>
                </div>
            </div>
        </dx-data-grid>
    </div>
</ng-template>
